import { get, put } from "./base";

export async function getReceiptInfo() {
    let respObj = await get("/sys/invoice/get-invoice");
    return respObj;
}

export async function updateReceiptInfo(params) {
    let respObj = await put("/sys/invoice", params);
    return respObj;
}